module.exports = __webpack_public_path__ + "static/media/ls.f5b822e5.svg";